import React from 'react'

type accessKeyIsValidProps = (
  accessKey: string,
  setValidateAccessKey: React.Dispatch<React.SetStateAction<boolean>>
) => boolean

export const accessKeyIsValid: accessKeyIsValidProps = (accessKey, setValidateAccessKey) => {
  if (accessKey && accessKey.length === 0) {
    setValidateAccessKey(false)
    return false
  } else {
    setValidateAccessKey(true)
    return true
  }
}
